import React from "react";

export default function FirstDate({ data, elem, credit, onChangeData }) {
  return (
    <div className="mb-2">
      <label for="comentario">
        {data.entryType === "recurrent"
          ? "Desde"
          : data.entryType === "credits"
          ? "Fecha Emisión"
          : elem.label}
        <span className="obligatory"> *</span>
      </label>
      <input
        type="date"
        className="form-control input-sm textInput especialGroup formHover"
        name={elem.id}
        value={data.entryType === "credits" ? credit?.firstDate : data?.date}
        max={data.entryType === "credits" ? credit?.finalDate : data?.finalDate}
        onChange={(e) => {
          onChangeData(e.target.value, e.target.id);
        }}
        id={elem.id}
      />
    </div>
  );
}
